import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {
  sum: 0,
  count: 0
}

const getSumActions = generateActions('externalpayments/sum/GET_FULL_INFO')

export const getSum = createAction(
  API_CONST,
  () => ({
    url: `externalpayments/sum`,
    actions: getSumActions
  })
)

export default handleActions({
  [getSumActions[0]]: state => {
    return ({ ...state, sum: 0, count: 0 })},
  [getSumActions[1]]: (state, { payload }) => {
  return ({ ...state, sum: payload[0].sum, count: payload[0].count })
},
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/externalpayments/index.js